import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase-config";
import { certMap } from "../assets/certImages/certImages";

function Certifications() {
  const [certs, setCerts] = useState([]);

  useEffect(() => {
    const fetchCerts = async () => {
      try {
        const certsRef = collection(db, "certifications");
        const q = query(certsRef, orderBy("issueDate", "desc"));
        const snapshot = await getDocs(q);

        const certsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setCerts(certsData);
      } catch (err) {
        console.error("Error fetching certifications:", err);
      }
    };

    fetchCerts();
  }, []);

  return (
    <div className="certificationsPage">
      <h1>Certifications</h1>
      {certs.length === 0 ? (
        <p>No certifications found.</p>
      ) : (
        certs.map((cert) => (
          <div className="cert" key={cert.credentialId}>
            <h2>{cert.title}</h2>
            <div className="certBody">
              <img
                src={certMap[cert.title] || null}
                alt={cert.title}
                style={{ maxWidth: "200px" }}
                className="certImage"
              />
              <div className="certDetails">
                <p>{cert.description}</p>
                <p>
                  Issue Date:{" "}
                  {cert.issueDate?.toDate
                    ? cert.issueDate
                        .toDate()
                        .toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })
                    : "Date unknown"}
                </p>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default Certifications;